import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    processClass: Yup.string(),
    source: Yup.string(),
    destination: Yup.string(),
    fileName: Yup.string(),
    fileContent: Yup.string(),
    fileSize: Yup.number(),
    fileCreationDate: Yup.date().validFormat("YYYY-MM-DD HH:mm:ss").typeError("Invalid date format. Only \"YYYY-MM-DD HH:mm:ss\" format is valid."),
    serverFilePath: Yup.string(),
    transferType: Yup.string(),
    transferMode: Yup.string(),
    processStatus: Yup.string(),
    statusDetail: Yup.string(),
    startTime: Yup.date().validFormat("YYYY-MM-DD HH:mm:ss").typeError("Invalid date format. Only \"YYYY-MM-DD HH:mm:ss\" format is valid."),
    endTime: Yup.date().validFormat("YYYY-MM-DD HH:mm:ss").typeError("Invalid date format. Only \"YYYY-MM-DD HH:mm:ss\" format is valid."),
    transactionId: Yup.string(),
    dockey: Yup.string(),
    retry: Yup.string(),
  })
}

export default makeValidationSchema
